import React from "react";
import PropTypes from "prop-types";
import { Upload, Icon, Button } from "antd";
import { getAuthToken } from "utilities/auth";
import { Modal } from "../../../node_modules/antd/lib/index";
import { DocumentViewer } from "components/index";

class FileUpload extends React.Component {
    state = {
        visible: false
    };
    onFileUploadStatusChange = ({ file }) => {
        if (file.status === "done") {
            this.props.onChange(
                this.props.multiple
                    ? 
                    this.props.value.push({
                        ...file.response,
                        name: file.response.file.split("/").reverse()[0]
                    })
                    : {
                        ...file.response,
                        name: file.response.file.split("/").reverse()[0]
                    }
            );
        }
        this.props.onFileUploadComplete();
    };
    viewDocument = () => {
        this.setState({
            visible: !this.state.visible
        });
    };
    render() {
        return (
            <React.Fragment>
                <Modal
                    visible={this.state.visible}
                    onOk={this.viewDocument}
                    onCancel={this.viewDocument}
                    width={700}
                    title={this.props.value && this.props.value.file_name}
                >
                    {this.props.value ? this.props.value.size ? this.props.value.map(_ => (
                        <DocumentViewer
                            key={_.id}
                            width={600}
                            height={800}
                            url={_.file}
                        />
                    )) : (
                        <DocumentViewer
                            width={600}
                            height={800}
                            url={this.props.value ? this.props.value.file : null}
                        />
                    ) : null}
                </Modal>
                {this.props.value ? 
                    this.props.viewable ? (
                        this.props.value.size ? 
                            this.props.value.toSet().toList().map(_ => 
                                <Button key={_.id} type={"link"} onClick={this.viewDocument}>
                                    {_.file_name}
                                </Button>
                            ).toList().toArray() : (
                                <Button type={"link"} onClick={this.viewDocument}>
                                    {this.props.value.file_name}
                                </Button>
                            )
                    ) : (
                        this.props.value.size ? this.props.value.map(_ => <div key={_.id}>{_.file_name}</div>).toList().toArray() : this.props.value.file_name
                    )
                    : null}
                <Upload
                    multiple={this.props.multiple}
                    action={this.props.uploadTarget}
                    showUploadList={false}
                    onPreview={this.props.showPreview ? this.handlePreview : null}
                    onChange={this.onFileUploadStatusChange}
                    data={file => {
                        return {
                            ...this.props.params,
                            file_name: file.name
                        };
                    }}
                    headers={{
                        Authorization: `Bearer ${getAuthToken().authToken}`
                    }}
                >
                    <Button type={"default"}>
                        Upload <Icon type={"upload"} />
                    </Button>
                </Upload>
            </React.Fragment>
        );
    }
}

FileUpload.propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
    onFileUploadComplete: PropTypes.func,
    uploadTarget: PropTypes.string,
    viewable: PropTypes.bool,
    params: PropTypes.object,
    multiple: PropTypes.bool,
    showPreview: PropTypes.bool
};

FileUpload.defaultProps = {
    multiple: false,
    showPreview: false
};

export default FileUpload;
